import { useEffect } from "react";

// Predisposizione aggancio iubenda: se REACT_APP_IUBENDA_SITE_ID è impostato,
// carica lo script del Cookie Solution di iubenda. Altrimenti no-op (banner interno).
export default function IubendaLoader() {
  useEffect(() => {
    const siteId = process.env.REACT_APP_IUBENDA_SITE_ID;
    if (!siteId) return;
    window._iub = window._iub || [];
    window._iub.csConfiguration = {
      siteId: Number(siteId),
      cookiePolicyId: Number(process.env.REACT_APP_IUBENDA_COOKIE_POLICY_ID || 0),
      lang: "it",
      banner: { position: "float-bottom-center", acceptButtonDisplay: true, rejectButtonDisplay: true },
    };
    const s = document.createElement("script");
    s.src = "https://cs.iubenda.com/autoblocking/" + siteId + ".js";
    s.async = true;
    document.body.appendChild(s);
    const s2 = document.createElement("script");
    s2.src = "//cdn.iubenda.com/cs/iubenda_cs.js";
    s2.async = true;
    document.body.appendChild(s2);
    return () => { s.remove(); s2.remove(); };
  }, []);
  return null;
}
